import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlarmClock1Alternate = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "alarm-clock-1-alternate" }),
		/* @__PURE__ */ _jsx("path", { d: "M21.5,12.252A9.5,9.5,0,1,0,6.125,19.713L3.793,22.045a1,1,0,0,0,0,1.414,1.015,1.015,0,0,0,1.414,0L7.863,20.8a9.492,9.492,0,0,0,8.274,0l2.656,2.656a1.011,1.011,0,0,0,1.414,0,1,1,0,0,0,0-1.414l-2.332-2.332A9.489,9.489,0,0,0,21.5,12.252Zm-17,0a7.5,7.5,0,1,1,7.5,7.5A7.509,7.509,0,0,1,4.5,12.252Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M7.4,2.269a.5.5,0,0,0,.129-.823,4.486,4.486,0,0,0-6.339,6.34.507.507,0,0,0,.445.155.5.5,0,0,0,.377-.284A11.019,11.019,0,0,1,7.4,2.269Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M19.5.252a4.485,4.485,0,0,0-3.033,1.194.5.5,0,0,0,.129.823,11.019,11.019,0,0,1,5.388,5.388.5.5,0,0,0,.376.284.51.51,0,0,0,.446-.155A4.486,4.486,0,0,0,19.5.252Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M15,11.252H13v-3.5a1,1,0,1,0-2,0v4.5a1,1,0,0,0,1,1h3a1,1,0,0,0,0-2Z" })
	]
});
export default SvgAlarmClock1Alternate;
